// ToFixList (timesheet rules §4, §5): what's left to fix before the period locks, one row per problem.
// On Hours each row starts with the person (PenKey); on a Timesheet it's their own. Then the day, the
// problem in words, its first fix as a small button that opens the quick edit with that fix chosen
// ("End it 3 p.m.", or "Check the day" where the fix is a guess), and Open the day. Nothing saves from
// here: the dialog does. Before the team's days are read, a row per person says how many they have
// and opens their Timesheet. Reads only --tofix-*; Button, Link and PenKey read their own.
import { Button } from '../../components/Button/Button.tsx';
import { Link } from '../../components/Link/Link.tsx';
import { PenKey } from '../../components/PenKey/PenKey.tsx';
import type { HoursView, ToFixRow } from '../timesheet-view.ts';
import './ToFixList.css';

export interface ToFixListProps {
  rows: ToFixRow[];
  /** Hours: each row names the person. */
  showPerson?: boolean;
  /** Its first fix: the quick edit, with that fix chosen (none for Check the day). */
  onFix: (row: ToFixRow) => void;
  /** Open the day: the quick edit, on its likeliest fix. */
  onOpenDay: (row: ToFixRow) => void;
  /** Before the days are read: how many each person has. */
  counts?: HoursView['toFixCounts'];
  onPerson?: (staffId: string) => void;
}

export function ToFixList({ rows, showPerson = false, onFix, onOpenDay, counts, onPerson }: ToFixListProps) {
  if (!rows.length && counts?.length)
    return (
      <ul className="fl-tofix">
        {counts.map((c) => (
          <li key={c.staffId} className="fl-tofix__row" data-person="">
            <span className="fl-tofix__who">
              <PenKey>{c.name}</PenKey>
            </span>
            <span className="fl-tofix__problem">{c.words}</span>
            {onPerson ? (
              <span className="fl-tofix__open">
                <Link onPress={() => onPerson(c.staffId)}>Their timesheet</Link>
              </span>
            ) : null}
          </li>
        ))}
      </ul>
    );
  return (
    <ul className="fl-tofix">
      {rows.map((r) => (
        <li key={`${r.staffId}:${r.id}`} className="fl-tofix__row" data-person={showPerson ? '' : undefined}>
          {showPerson ? (
            <span className="fl-tofix__who">
              <PenKey pen={r.pen ?? null}>{r.name}</PenKey>
            </span>
          ) : null}
          <span className="fl-tofix__day">{r.day}</span>
          <span className="fl-tofix__problem">{r.problem}</span>
          <span className="fl-tofix__fix">
            <Button size="sm" onPress={() => onFix(r)}>
              {r.fix.label}
            </Button>
          </span>
          <span className="fl-tofix__open">
            <Link onPress={() => onOpenDay(r)}>Open the day</Link>
          </span>
        </li>
      ))}
    </ul>
  );
}
